define('modules/editor/views/controls/alignbar',['require','exports','module','base/itemview','ldsh!../../templates/controls/alignbar'],function(require, exports, module){
  "use strict";
  
  var BaseView = require("base/itemview");

  var AlignmentBarView = BaseView.extend({
    template: require("ldsh!../../templates/controls/alignbar"),
    constructor: function(options){
      var className = options.model.get("top")? "h-side" : "v-side";
      this.className = ["align-guide", className].join(" ");
      BaseView.__super__.constructor.apply(this, arguments);
    },
    onRender: function() {
      var pos = _.pairs(this.model.attributes);
      this.$el.css.apply(this.$el, pos[0]);
    }
  });

  module.exports = AlignmentBarView;
});

